/**
 * main.js
 *
 * Copyright (c) 2026 Eric Seigne <eric.seigne@cap-rel.fr>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

import { App } from './app/App.js'
import { Router } from './app/Router.js'
import { Store } from './store/Store.js'
import { i18n } from './i18n/index.js'

// Initialize global store
window.store = new Store()


// Initialize theme from localStorage
const savedTheme = localStorage.getItem('mvplan_theme') || 'dark'
document.documentElement.setAttribute('data-theme', savedTheme)

// Initialize i18n with stored language (localStorage takes priority)
const savedLocale = localStorage.getItem('mvplan_locale') || window.store.state.settings.language || 'en'
i18n.setLocale(savedLocale)
window.i18n = i18n

// Subscribe to language changes
window.store.subscribe((state) => {
  if (state.settings.language !== i18n.getLocale()) {
    i18n.setLocale(state.settings.language)
  }
})

// Initialize router and app
const router = new Router()
const app = new App(document.getElementById('app'), router)

app.mount()
